import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

interface BlogBreadcrumbProps {
    articleTitle: string;
}

export default function BlogBreadcrumb({ articleTitle }: BlogBreadcrumbProps) {
    return (
        <nav className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <ol className="flex items-center space-x-1 text-sm">
                    <li>
                        <Link
                            to="/"
                            className="text-gray-500 hover:text-gray-700 transition-colors duration-200 flex items-center"
                        >
                            <Home className="w-4 h-4" />
                        </Link>
                    </li>
                    <li className="flex items-center">
                        <ChevronRight className="text-gray-400 mx-1 w-4 h-4" />
                        <Link
                            to="/blog"
                            className="text-gray-500 hover:text-gray-700 transition-colors duration-200 font-medium"
                        >
                            Blog
                        </Link>
                    </li>
                    <li className="flex items-center">
                        <ChevronRight className="text-gray-400 mx-1 w-4 h-4" />
                        <span className="text-gray-900 font-medium truncate max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl">
                            {articleTitle}
                        </span>
                    </li>
                </ol>
            </div>
        </nav>
    );
}
